import React from "react";
import { Link, Routes, Route } from "react-router-dom";

import "./styles/dashboard.css";

import Home from "./Home";

import NewArrivals from "./NewArrivals";
import FeatureCollection from "./FeatureCollection";
import ResinCollection from "./ResinCollection";
import FesiCollection from "./FesiCollection";
import PremiumItem from "./PremiumItem";

import Collection1 from "./collections/Collection1";
import Collection2 from "./collections/Collection2";
import Collection3 from "./collections/Collection3";
import Collection4 from "./collections/Collection4";
import Collection5 from "./collections/Collection5";

import MenShirt from "./MenShirt";
import WomenShirt from "./WomenShirt";
import KidsShirt from "./KidsShirt";

import About from "./About";

import Account from "./Account";
import TexturePaint from "./TexturePaint";
import Sale from "./Sale";
import Orders from "./Orders";
import SidebarCatalogs from "./SidebarCatalogs";
import CatalogProducts from "./CatalogProducts";
import CatalogsManagerModal from "./CatalogsManagerModal";

import Stories from "./stories/Stories";
import CreateStory from "./stories/CreateStory";
import EditStory from "./stories/EditStory";

const Dashboard = ({ user, setUser }) => {
  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
    window.location.href = "/login";
  };

  return (
    <div className="d-flex">
      <div className="d-flex flex-column flex-shrink-0 p-3 sidebar">
        <div className="sidebar-header">
          <span className="d-flex align-items-center mb-5 justify-content-center mb-3 mb-md-0 link-light fw-bold">
            <span className="fs-1">Libas Store</span>
          </span>
          <hr />
        </div>

        <div className="sidebar-content">
          <ul className="nav nav-pills flex-column mb-3">
            <li>
              <div className="nav-link link-light">
                <CatalogsManagerModal />
              </div>
            </li>
          </ul>
          <ul className="nav nav-pills flex-column mb-auto">
            <li>
              <Link to="home" className="nav-link link-light">
                Cover Images
              </Link>
            </li>
            <li>
              <Link to="new-arrivals" className="nav-link link-light">
                New Arrivals
              </Link>
            </li>
            <li>
              <Link to="feature-collection" className="nav-link link-light">
                Feature Collection
              </Link>
            </li>
            <li>
              <Link to="resin-collection" className="nav-link link-light">
                Resin Collection
              </Link>
            </li>
            <li>
              <Link to="fesi-collection" className="nav-link link-light">
                Fesi Collection
              </Link>
            </li>
            <li>
              <Link to="premium-item" className="nav-link link-light">
                Premium Item
              </Link>
            </li>

            <ul className="mt-3 nav nav-pills flex-column mb-auto">
              <li>
                <Link to="collection1" className="nav-link link-light">
                  Collection 1
                </Link>
              </li>
              <li>
                <Link to="collection2" className="nav-link link-light">
                  Collection 2
                </Link>
              </li>
              <li>
                <Link to="collection3" className="nav-link link-light">
                  Collection 3
                </Link>
              </li>
              <li>
                <Link to="collection4" className="nav-link link-light">
                  Collection 4
                </Link>
              </li>
              <li>
                <Link to="collection5" className="nav-link link-light">
                  Collection 5
                </Link>
              </li>
            </ul>

            <ul className="mt-3 nav nav-pills flex-column mb-auto">
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle link-light"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Men Shirts
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="men-shirt">
                      Men Shirts
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="sale/menShirt">
                      Sale
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle link-light"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Women Shirts
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="women-shirt">
                      Women Shirts
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="sale/womenShirt">
                      Sale
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle link-light"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Resin Art
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="resin-art">
                      Resin Art
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="sale/resinArt">
                      Sale
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle link-light"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Texture Paint
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="texture-paint">
                      Texture Paint
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="sale/texturePaint">
                      Sale
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>

            <SidebarCatalogs />

            <ul className="mt-3 nav nav-pills flex-column mb-auto">
              <li>
                <Link to="orders" className="nav-link link-light">
                  Orders
                </Link>
              </li>

              <li>
                <Link to="about" className="nav-link link-light">
                  About
                </Link>
              </li>
            </ul>
          </ul>

          <ul className="mt-3 nav nav-pills flex-column mb-auto">
            <li>
              <Link to="stories" className="nav-link link-light">
                Web Stories
              </Link>
            </li>
          </ul>
        </div>

        <div className="sidebar-footer">
          <ul className="nav nav-pills flex-column mt-auto">
            <hr />
            <Link to="account" className="nav-link link-light">
              Account
            </Link>
            <li
              className="nav-link link-light text-center"
              onClick={handleLogout}
            >
              Logout
            </li>
          </ul>
        </div>
      </div>
      <div className="container-fluid main-container">
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="new-arrivals" element={<NewArrivals />} />
          <Route path="feature-collection" element={<FeatureCollection />} />
          <Route path="resin-collection" element={<ResinCollection />} />
          <Route path="fesi-collection" element={<FesiCollection />} />
          <Route path="premium-item" element={<PremiumItem />} />

          <Route path="collection1" element={<Collection1 />} />
          <Route path="collection2" element={<Collection2 />} />
          <Route path="collection3" element={<Collection3 />} />
          <Route path="collection4" element={<Collection4 />} />
          <Route path="collection5" element={<Collection5 />} />

          <Route path="men-shirt" element={<MenShirt />} />
          <Route path="women-shirt" element={<WomenShirt />} />
          <Route path="resin-art" element={<KidsShirt />} />
          <Route path="texture-paint" element={<TexturePaint />} />
          <Route path="sale/:salepath" element={<Sale />} />

          <Route
            path="catalog/:catalogName/:collectionName"
            element={<CatalogProducts />}
          />

          <Route path="orders" element={<Orders />} />

          <Route path="about" element={<About />} />

          <Route path="stories" element={<Stories />} />
          <Route path="stories/new" element={<CreateStory />} />
          <Route path="stories/edit/:storyId" element={<EditStory />} />

          <Route
            path="account"
            element={<Account user={user} setUser={setUser} />}
          />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
